import { useEffect, useRef, useState } from 'react';
import { copyToClipboard } from '@utils/helpers';
import { ThemeButtonIcon } from '@shared/ui/buttons';

export function CopyThemeButtonIcon({ value }) {
  const [isCopied, setIsCopied] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  function handleClick() {
    copyToClipboard(value);
    setIsCopied(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setIsCopied(false), 1000);
  }

  return (
    <ThemeButtonIcon onClick={handleClick} icon={isCopied ? 'check' : 'copy'} />
  );
}
